import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { VControllerViewABI } from "./abi/VControllerViewABI";

export class VControllerViewResult{
    public vxRatio:string;
    public contedBalance:string;
    public apr:string;
}
export class VControllerViewContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, VControllerViewABI.GetABI(), provider);
    }

    async getVXRateAsync(): Promise<VControllerViewResult>
    {
        const result = await this._call("countView");
        if (!result) return;
        result.vxRatio = this._toDecimal(result.vxRatio);
        result.contedBalance = this._toDecimal(result.contedBalance);
        result.apr = this._toDecimal(result.apr);
        return result;
    }
    async getAPRAsync(): Promise<string>
    {
        const apr = await this._call("apr");
        return this._toDecimal(apr);
    }
    async getCountedBalanceAsync(): Promise<string>
    {
        const balance = await this._call("countedBalance");
        return this._toDecimal(balance);
    }
    async getValidatorsCountAsync(): Promise<string>
    {
        const validatorsCount = await this._call("validatorsCount");
        return validatorsCount;
    }

    async getValidatorsToExitAsync(): Promise<string>
    {
        const validatorsCount = await this._call("validatorsToExit");
        return validatorsCount;
    }

    async getVXAddressAsync(): Promise<string>
    {
        const address = await this._call("vx");
        return address;
    }
    async getVPoolAddressAsync(): Promise<string>
    {
        const address = await this._call("vpool");
        return address;
    }

    async getValidatorGas(): Promise<string>
    {
        const gas = await this._call("validatorGas");
        return this._toDecimal(gas);
    }
}